export class UsuarioModel {
  codigo: number = 0;
  empresa: any;
  nome: string = '';
  operadorCaixa: boolean = false;
  senha: string = '';
  logoEmpresa: string = '';
  bloqueiaCancelaProd: boolean = true;
  pdV_CancelarPedido: boolean = false;
  acessarRetaguarda: boolean = false;
  verQuantiaCaixa: boolean = false;
}
